import { MockDataProvider } from "./providers/mock/mock-provider";
import { ApiDataProvider } from "./providers/real/api-provider";
import { WiremockHybridProvider } from "./providers/wiremock-hybrid-provider";
/** Подставляется Webpack `DefinePlugin` на этапе сборки (см. `webpack.config.cjs`). */
const providerKind = process.env.ITR_DATA_PROVIDER ?? "mock";
const createProvider = () => {
    if (providerKind === "api") {
        return new ApiDataProvider();
    }
    if (providerKind === "wiremock") {
        return new WiremockHybridProvider();
    }
    return new MockDataProvider();
};
export const apiClient = createProvider();
